import { createFileRoute, Link, Outlet, useRouterState } from '@tanstack/react-router';

export const Route = createFileRoute('/admin/suporte')({
  component: () => {
    // Quando há subrota (/admin/suporte/$userId) ela cuida do render.
    // Aqui o Outlet renderiza tanto o index quanto o detalhe.
    const state = useRouterState();
    void state;
    return <Outlet />;
  },
});

// Garante export pra TanStack Router gerar a tree
export { Link };
